// extracted by mini-css-extract-plugin
module.exports = {"nfBtn":"NotFound_nfBtn__c3CZb","navLink":"NotFound_navLink__2_Osw","verticalAlign":"NotFound_verticalAlign__fKPyp"};